<template>
  <v-container fluid ma-0 pa-0 px-4 >
     <div class="fixed-header" :class="{'mobile': $vuetify.breakpoint.smAndDown}"><!-- if has summary fields add class 'with-summary' -->
        <v-layout  align-center fill-height class="fixed-header-wrapper">
          <v-flex shrink class="text-truncate" pr-4>
            <v-tooltip color="secondary" bottom>
              <template v-slot:activator="{ on }">
                <h2 v-on="on" class="p-relative text-truncate" >
                  Jobs Schedular
                </h2>
              </template>
                <span>Jobs</span>
              </v-tooltip>
            <h4 class="pt-1 sub-header ">Lorem ipsum dolor</h4>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
      </div>
    <v-flex xs12 pt-4>
      <v-hover>
        <v-expansion-panel
            slot-scope="{ hover }"
            :class="`elevation-${hover ? 5 : 2}`"
            class="mb-3 parent-expansion withRemove"
            style="position:relative">
              <div class="horiz-left-coloured-bg">
                     <font-awesome-icon
                color="secondary"
                size="lg"
                icon="file-import"
                class="horiz-left-coloured-bg--icon font-awesome mt-1 ml-2"
              ></font-awesome-icon>
              </div>
              <v-expansion-panel-content class="rounded-3">
                <div slot="header">
                  <h3
                  class="text-truncate py-1 ml-2 pl-4 horiz-left-coloured-bg--padding-header">
                  Importing PRODUCT cases into the CLAIM bucket</h3>
                  <h4 class="horiz-left-coloured-bg--padding-header ml-4">
                    Scheduled for
                    <span style="font-weight:700">00.05 every day</span>.
                  </h4>
                  <v-btn  @click.stop class="expansion-remove-btn" icon>
                    <v-icon color="error">cancel</v-icon>
                  </v-btn>
                </div>
                <v-layout class="horiz-left-coloured-bg--padding">
                  <v-flex px-4 pb-4>
                    <form>
                      <v-layout wrap row class="pa-0 mt-3">
                        <v-container ma-0 pa-0>
                          <v-flex xs12 sm6>
                            <v-text-field
                              label="Job name"
                              class
                              box
                              value="Importing PRODUCT cases into the CLAIM bucket"
                            ></v-text-field>
                          </v-flex>
                        </v-container>
                        <v-container ma-0 pa-0>
                          <v-autocomplete
                            class="mr-3"
                            :items="everyItems"
                            box
                            label="Every"
                            v-model="everyValue"
                            no-data-text="No results"
                            dense
                            append-icon="keyboard_arrow_down"
                            style="width:150px; display:inline-block"
                          ></v-autocomplete>
                          <v-flex class="d-inline" v-if="everyValue === 'Hour'">
                            <h4 style="display:inline-block; vertical-align:middle" class="pb-4 mr-3">at</h4>
                            <v-autocomplete
                              class="mr-3"
                              :items="minsItems"
                              box
                              label="Mins"
                              v-model="minsValue"
                              no-data-text="No results"
                              dense
                              append-icon="keyboard_arrow_down"
                              style="width:85px; display:inline-block"
                            ></v-autocomplete>
                            <h4
                              class="pb-4"
                              style="display:inline-block; vertical-align:middle"
                            >past the hour.</h4>
                          </v-flex>
                          <v-flex class="d-inline" v-if="everyValue === 'Day'">
                            <h4 style="display:inline-block; vertical-align:middle" class="pb-4 mr-3">at</h4>
                            <v-autocomplete
                              class="mr-1"
                              :items="dayHourItems"
                              box
                              label="Hrs"
                              v-model="dayHourValue"
                              no-data-text="No results"
                              dense
                              append-icon="keyboard_arrow_down"
                              style="width:85px; display:inline-block"
                            ></v-autocomplete>
                            <v-autocomplete
                              class="mr-3"
                              :items="dayMinsItems"
                              box
                              label="Mins"
                              v-model="dayMinsValue"
                              no-data-text="No results"
                              dense
                              append-icon="keyboard_arrow_down"
                              style="width:85px; display:inline-block"
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex class="d-inline" v-if="everyValue === 'Week'">
                            <h4 style="display:inline-block; vertical-align:middle" class="pb-4 mr-3">on</h4>
                            <v-autocomplete
                              class="mr-3"
                              :items="weekDayItems"
                              box
                              label="Day"
                              v-model="weekDayValue"
                              no-data-text="No results"
                              dense
                              append-icon="keyboard_arrow_down"
                              style="width:125px; display:inline-block"
                            ></v-autocomplete>
                            <h4 style="display:inline-block; vertical-align:middle" class="pb-4 mr-3">at</h4>
                            <v-autocomplete
                              class="mr-1"
                              :items="weekHourItems"
                              box
                              label="Hrs"
                              v-model="weekHourValue"
                              no-data-text="No results"
                              dense
                              append-icon="keyboard_arrow_down"
                              style="width:85px; display:inline-block"
                            ></v-autocomplete>
                            <v-autocomplete
                              class="mr-3"
                              :items="weekMinsItems"
                              box
                              label="Mins"
                              v-model="weekMinsValue"
                              no-data-text="No results"
                              dense
                              append-icon="keyboard_arrow_down"
                              style="width:85px; display:inline-block"
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex class="d-inline" v-if="everyValue === 'Month'">
                            <h4
                              style="display:inline-block; vertical-align:middle"
                              class="pb-4 mr-3"
                            >on the</h4>
                            <v-autocomplete
                              class="mr-3"
                              :items="monthDateItems"
                              box
                              label="Date"
                              v-model="monthDateValue"
                              no-data-text="No results"
                              dense
                              append-icon="keyboard_arrow_down"
                              style="width:85px; display:inline-block"
                            ></v-autocomplete>
                            <h4 style="display:inline-block; vertical-align:middle" class="pb-4 mr-3">at</h4>
                            <v-autocomplete
                              class="mr-1"
                              :items="monthHourItems"
                              box
                              label="Hrs"
                              v-model="monthHourValue"
                              no-data-text="No results"
                              dense
                              append-icon="keyboard_arrow_down"
                              style="width:85px; display:inline-block"
                            ></v-autocomplete>
                            <v-autocomplete
                              class="mr-3"
                              :items="monthMinsItems"
                              box
                              label="Mins"
                              v-model="monthMinsValue"
                              no-data-text="No results"
                              dense
                              append-icon="keyboard_arrow_down"
                              style="width:85px; display:inline-block"
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex class="d-inline" v-if="everyValue === 'Year'">
                            <h4
                              style="display:inline-block; vertical-align:middle"
                              class="pb-4 mr-3"
                            >on the</h4>
                            <v-autocomplete
                              class="mr-3"
                              :items="yearDateItems"
                              box
                              label="Date"
                              v-model="yearDateValue"
                              no-data-text="No results"
                              dense
                              append-icon="keyboard_arrow_down"
                              style="width:85px; display:inline-block"
                            ></v-autocomplete>
                            <h4 style="display:inline-block; vertical-align:middle" class="pb-4 mr-3">of</h4>
                            <v-autocomplete
                              class="mr-3"
                              :items="yearMonthItems"
                              box
                              label="Month"
                              v-model="yearMonthValue"
                              no-data-text="No results"
                              dense
                              append-icon="keyboard_arrow_down"
                              style="width:125px; display:inline-block"
                            ></v-autocomplete>
                            <h4 style="display:inline-block; vertical-align:middle" class="pb-4 mr-3">at</h4>
                            <v-autocomplete
                              class="mr-1"
                              :items="monthHourItems"
                              box
                              label="Hrs"
                              v-model="monthHourValue"
                              no-data-text="No results"
                              dense
                              append-icon="keyboard_arrow_down"
                              style="width:85px; display:inline-block"
                            ></v-autocomplete>
                            <v-autocomplete
                              class="mr-3"
                              :items="monthMinsItems"
                              box
                              label="Mins"
                              v-model="monthMinsValue"
                              no-data-text="No results"
                              dense
                              append-icon="keyboard_arrow_down"
                              style="width:85px; display:inline-block"
                            ></v-autocomplete>
                          </v-flex>
                        </v-container>
                        <v-container ma-0 pa-0>
                          <v-flex xs12>
                            <v-text-field
                              label="URL"
                              class
                              value="https://dev.caseblocks.com/string#$%^^$#^#^"
                              box
                            ></v-text-field>
                          </v-flex>
                          <h4>Payload (JSON)</h4>
                          <edit-code-pane :code="payloadValue" language="json"></edit-code-pane>
                        </v-container>
                      </v-layout>
                    </form>
                  </v-flex>
                </v-layout>
            </v-expansion-panel-content>
        </v-expansion-panel>
      </v-hover>
    </v-flex>
    <v-btn
        v-show="addJobButton"
        v-on:click="addJobForm = true; addJobButton = false"
        class="ml-0 mt-0"
        color="secondary"
      >Schedule a job</v-btn>
      <form v-show="addJobForm">
        <v-layout wrap row class="pa-4 white-bg elevation-2 rounded-3">
          <v-container ma-0 pa-0>
            <v-flex xs12 sm6>
              <v-text-field label="Job name" class box></v-text-field>
            </v-flex>
          </v-container>
          <v-container ma-0 pa-0>
            <v-autocomplete
              class="mr-3"
              :items="everyItems"
              box
              label="Every"
              v-model="everyValue"
              no-data-text="No results"
              dense
              append-icon="keyboard_arrow_down"
              style="width:150px; display:inline-block"
            ></v-autocomplete>
            <v-flex class="d-inline" v-if="everyValue === 'Hour'">
              <h4 style="display:inline-block; vertical-align:middle" class="pb-4 mr-3">at</h4>
              <v-autocomplete
                class="mr-3"
                :items="minsItems"
                box
                label="Mins"
                v-model="minsValue"
                no-data-text="No results"
                dense
                append-icon="keyboard_arrow_down"
                style="width:85px; display:inline-block"
              ></v-autocomplete>
              <h4 class="pb-4" style="display:inline-block; vertical-align:middle">past the hour.</h4>
            </v-flex>
            <v-flex class="d-inline" v-if="everyValue === 'Day'">
              <h4 style="display:inline-block; vertical-align:middle" class="pb-4 mr-3">at</h4>
              <v-autocomplete
                class="mr-1"
                :items="dayHourItems"
                box
                label="Hrs"
                v-model="dayHourValue"
                no-data-text="No results"
                dense
                append-icon="keyboard_arrow_down"
                style="width:85px; display:inline-block"
              ></v-autocomplete>
              <v-autocomplete
                class="mr-3"
                :items="dayMinsItems"
                box
                label="Mins"
                v-model="dayMinsValue"
                no-data-text="No results"
                dense
                append-icon="keyboard_arrow_down"
                style="width:85px; display:inline-block"
              ></v-autocomplete>
            </v-flex>
            <v-flex class="d-inline" v-if="everyValue === 'Week'">
              <h4 style="display:inline-block; vertical-align:middle" class="pb-4 mr-3">on</h4>
              <v-autocomplete
                class="mr-3"
                :items="weekDayItems"
                box
                label="Day"
                v-model="weekDayValue"
                no-data-text="No results"
                dense
                append-icon="keyboard_arrow_down"
                style="width:125px; display:inline-block"
              ></v-autocomplete>
              <h4 style="display:inline-block; vertical-align:middle" class="pb-4 mr-3">at</h4>
              <v-autocomplete
                class="mr-1"
                :items="weekHourItems"
                box
                label="Hrs"
                v-model="weekHourValue"
                no-data-text="No results"
                dense
                append-icon="keyboard_arrow_down"
                style="width:85px; display:inline-block"
              ></v-autocomplete>
              <v-autocomplete
                class="mr-3"
                :items="weekMinsItems"
                box
                label="Mins"
                v-model="weekMinsValue"
                no-data-text="No results"
                dense
                append-icon="keyboard_arrow_down"
                style="width:85px; display:inline-block"
              ></v-autocomplete>
            </v-flex>
            <v-flex class="d-inline" v-if="everyValue === 'Month'">
              <h4 style="display:inline-block; vertical-align:middle" class="pb-4 mr-3">on the</h4>
              <v-autocomplete
                class="mr-3"
                :items="monthDateItems"
                box
                label="Date"
                v-model="monthDateValue"
                no-data-text="No results"
                dense
                append-icon="keyboard_arrow_down"
                style="width:85px; display:inline-block"
              ></v-autocomplete>
              <h4 style="display:inline-block; vertical-align:middle" class="pb-4 mr-3">at</h4>
              <v-autocomplete
                class="mr-1"
                :items="monthHourItems"
                box
                label="Hrs"
                v-model="monthHourValue"
                no-data-text="No results"
                dense
                append-icon="keyboard_arrow_down"
                style="width:85px; display:inline-block"
              ></v-autocomplete>
              <v-autocomplete
                class="mr-3"
                :items="monthMinsItems"
                box
                label="Mins"
                v-model="monthMinsValue"
                no-data-text="No results"
                dense
                append-icon="keyboard_arrow_down"
                style="width:85px; display:inline-block"
              ></v-autocomplete>
            </v-flex>
            <v-flex class="d-inline" v-if="everyValue === 'Year'">
              <h4 style="display:inline-block; vertical-align:middle" class="pb-4 mr-3">on the</h4>
              <v-autocomplete
                class="mr-3"
                :items="yearDateItems"
                box
                label="Date"
                v-model="yearDateValue"
                no-data-text="No results"
                dense
                append-icon="keyboard_arrow_down"
                style="width:85px; display:inline-block"
              ></v-autocomplete>
              <h4 style="display:inline-block; vertical-align:middle" class="pb-4 mr-3">of</h4>
              <v-autocomplete
                class="mr-3"
                :items="yearMonthItems"
                box
                label="Month"
                v-model="yearMonthValue"
                no-data-text="No results"
                dense
                append-icon="keyboard_arrow_down"
                style="width:125px; display:inline-block"
              ></v-autocomplete>
              <h4 style="display:inline-block; vertical-align:middle" class="pb-4 mr-3">at</h4>
              <v-autocomplete
                class="mr-1"
                :items="monthHourItems"
                box
                label="Hrs"
                v-model="monthHourValue"
                no-data-text="No results"
                dense
                append-icon="keyboard_arrow_down"
                style="width:85px; display:inline-block"
              ></v-autocomplete>
              <v-autocomplete
                class="mr-3"
                :items="monthMinsItems"
                box
                label="Mins"
                v-model="monthMinsValue"
                no-data-text="No results"
                dense
                append-icon="keyboard_arrow_down"
                style="width:85px; display:inline-block"
              ></v-autocomplete>
            </v-flex>
          </v-container>
          <v-container ma-0 pa-0>
            <v-flex xs12>
              <v-text-field label="URL" class box></v-text-field>
            </v-flex>
            <h4>Payload (JSON)</h4>
            <edit-code-pane language="json"></edit-code-pane>
          </v-container>

          <v-flex xs12 class="pt-3">
            <v-btn class="ml-0 mt-0 mr-2" color="success">Create Job</v-btn>
            <v-btn
              color="error"
              class="mt-0 ml-0"
              v-on:click="addJobForm = false; addJobButton = true"
            >Cancel</v-btn>
          </v-flex>
        </v-layout>
      </form>
  </v-container>
</template>

<script>
import EditCodePane from '@/components/shared/editCodePane.vue'

export default {
  components: { EditCodePane },
  data() {
    return {
      everyValue: "Minute",
      everyItems: ["Minute", "Hour", "Day", "Week", "Month", "Year"],
      minsValue: "00",
      minsItems: [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
        "32",
        "33",
        "34",
        "35",
        "36",
        "37",
        "38",
        "39",
        "40",
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "47",
        "48",
        "49",
        "50",
        "51",
        "52",
        "53",
        "54",
        "55",
        "56",
        "57",
        "58",
        "59"
      ],
      dayMinsItems: [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
        "32",
        "33",
        "34",
        "35",
        "36",
        "37",
        "38",
        "39",
        "40",
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "47",
        "48",
        "49",
        "50",
        "51",
        "52",
        "53",
        "54",
        "55",
        "56",
        "57",
        "58",
        "59"
      ],
      dayMinsValue: "00",
      dayHourItems: [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23"
      ],
      dayHourValue: "00",
      weekMinsItems: [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
        "32",
        "33",
        "34",
        "35",
        "36",
        "37",
        "38",
        "39",
        "40",
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "47",
        "48",
        "49",
        "50",
        "51",
        "52",
        "53",
        "54",
        "55",
        "56",
        "57",
        "58",
        "59"
      ],
      weekMinsValue: "00",
      weekHourItems: [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23"
      ],
      weekHourValue: "00",
      weekDayValue: "Sunday",
      weekDayItems: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      monthDateValue: "1st",
      monthDateItems: [
        "1st",
        "2nd",
        "3rd",
        "4th",
        "5th",
        "6th",
        "7th",
        "6th",
        "8th",
        "9th",
        "10th",
        "11th",
        "12th",
        "13th",
        "14th",
        "15th",
        "16th",
        "17th",
        "18th",
        "19th",
        "20th",
        "21st",
        "22nd",
        "23rd",
        "24th",
        "25th",
        "26th",
        "27th",
        "28th",
        "29th",
        "30th",
        "31st"
      ],
      monthMinsItems: [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
        "32",
        "33",
        "34",
        "35",
        "36",
        "37",
        "38",
        "39",
        "40",
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "47",
        "48",
        "49",
        "50",
        "51",
        "52",
        "53",
        "54",
        "55",
        "56",
        "57",
        "58",
        "59"
      ],
      monthMinsValue: "00",
      monthHourItems: [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23"
      ],
      monthHourValue: "00",
      yearHourValue: "00",
      yearMinsItems: [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
        "32",
        "33",
        "34",
        "35",
        "36",
        "37",
        "38",
        "39",
        "40",
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "47",
        "48",
        "49",
        "50",
        "51",
        "52",
        "53",
        "54",
        "55",
        "56",
        "57",
        "58",
        "59"
      ],
      yearMinsValue: "00",
      yearHourItems: [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23"
      ],
      yearDateValue: "1st",
      yearDateItems: [
        "1st",
        "2nd",
        "3rd",
        "4th",
        "5th",
        "6th",
        "7th",
        "6th",
        "8th",
        "9th",
        "10th",
        "11th",
        "12th",
        "13th",
        "14th",
        "15th",
        "16th",
        "17th",
        "18th",
        "19th",
        "20th",
        "21st",
        "22nd",
        "23rd",
        "24th",
        "25th",
        "26th",
        "27th",
        "28th",
        "29th",
        "30th",
        "31st"
      ],
      yearMonthValue: "January",
      yearMonthItems: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      addJobButton: true,
      addJobForm: false,
      payloadValue: "function myScript(){return 100;}\n",
      cmOptionsPayload: {
        tabSize: 4,
        mode: {
          name: "javascript",
          json: true
        },
        theme: "base16-light",
        autoRefresh: true,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        highlightDifferences: true,
        lineWrapping: true,
        foldGutter: true,
        styleSelectedText: true,
        showCursorWhenSelecting: true
      }
    }
  }
}
</script>

<style>
.jobs {
  height: 200px !important;
  min-height: 200px !important;
}
</style>
